export enum AssessmentStatuses {
  InProgress = "IN_PROGRESS",
  Active = "ACTIVE",
}

export class AssessmentInfo {
  status: string;
  assessmentId: number;
  solvedAssessmentId: number;
}



// WEBPACK FOOTER //
// ./src/models/patient-chart/assessmentInfo.ts